<template>
  <div>
    <div>
      <div class="Home">
        <div class="Home-W">
          <div>
            <Homeinput></Homeinput>
          </div>
          <div class="Hombox_list">
            <div class="Hombox_left">
              <div class="Hblbox">
                <div class="Hblbox_l">
                  <img src="../../assets/pc/seach/1.png" />
                </div>
                <div class="Hblbox_r">
                  <div class="Hblbox_title">Block height</div>
                  <div class="Hblbox_content">
                    {{ Number(currentHeight).toLocaleString() }}
                  </div>
                  <div class="Hblbox_bott">
                    <div class="boxnum">
                      + {{ Number(last24hHeight).toLocaleString() }}
                    </div>
                    <div class="boxtit">Last 24h</div>
                  </div>
                </div>
              </div>
              <div class="Hblbox">
                <div class="Hblbox_l">
                  <img src="../../assets/pc/seach/4.png" />
                </div>
                <div class="Hblbox_r">
                  <div class="Hblbox_title">Total Accounts</div>
                  <div class="Hblbox_content">
                    {{ Number(totalAccounts).toLocaleString() }}
                  </div>
                  <div class="Hblbox_bott">
                    <div class="boxnum">
                      {{ Number(activeToday).toLocaleString() }}
                    </div>
                    <div class="boxtit">active today</div>
                  </div>
                </div>
              </div>
              <div class="Hblbox">
                <div class="Hblbox_l">
                  <img src="../../assets/pc/seach/2.png" />
                </div>
                <div class="Hblbox_r">
                  <div class="Hblbox_title">TTOS Supply</div>
                  <div class="Hblbox_content">
                    {{ Number(currentSupply).toLocaleString() }}
                  </div>
                  <div class="Hblbox_bott">
                    <div class="boxnum">{{ last24hSupplyPercent }}</div>
                    <div class="boxtit">Last 24h</div>
                  </div>
                </div>
              </div>
              <div class="Hblbox">
                <div class="Hblbox_l">
                  <img src="../../assets/pc/seach/5.png" />
                </div>
                <div class="Hblbox_r">
                  <div class="Hblbox_title">TTOS Burned</div>
                  <div class="Hblbox_content">
                    {{ Number(currentBurn).toLocaleString() }}
                  </div>
                  <div class="Hblbox_bott">
                    <div class="boxnum">
                      {{ Number(last24hBurn).toLocaleString() }}
                    </div>
                    <div class="boxtit">Last 24h</div>
                  </div>
                </div>
              </div>
              <div class="Hblbox">
                <div class="Hblbox_l">
                  <img src="../../assets/pc/seach/3.png" />
                </div>
                <div class="Hblbox_r">
                  <div class="Hblbox_title">Validators</div>
                  <div class="Hblbox_content">
                    {{ Number(validatorCount).toLocaleString() }}
                  </div>
                  <div class="Hblbox_bott">
                    <div class="boxnum">
                      {{ Number(nodeCount).toLocaleString() }}
                    </div>
                    <div class="boxtit">All nodes</div>
                  </div>
                </div>
              </div>
              <!-- <div class="Hblbox">
                <TimeBox></TimeBox>
              </div> -->
              <div class="Hblbox">
                <!-- <div class="Hblbox_l">
                  <img src="../../assets/pc/seach/1.png" />
                </div> -->
                <div class="Hblbox_r rights">
                  <div class="Hblbox_title">
                    To the next bonus era
                    <el-tooltip placement="right" popper-class="toolTipClass">
                      <div slot="content">
                        In the Transformers blockchain, an "era" is defined as
                        an<br />
                        incentive cycle lasting 24 hours, during which<br />
                        validators must claim their rewards within the
                        <br />following 24 hours after the era concludes.<br />
                        Rewards not claimed within this 24-hour<br />
                        timeframe will be considered invalid.
                      </div>
                      <img src="../../assets/pc/Index/tip.png" />
                    </el-tooltip>
                    <!-- <img
                      src="../../assets/pc/Index/tip.png"
                    /> -->
                  </div>
                  <div class="Hblbox_content">
                    {{ theTime2 }} h {{ theTime1 }} m {{ theTime }} s
                  </div>
                  <div class="Hblbox_bott">
                    <div class="progress">
                      <el-progress
                        type="line"
                        :percentage="Number(percentage)"
                        class="el-bg-inner-running"
                      ></el-progress>
                    </div>
                    <!-- <div class="boxnum">+2355555</div>
                    <div class="boxtit">Last 24h</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="Hombox_right">
              <div class="Homrightbox">
                <div class="Hombox_shang">
                  <div class="Hombox_sl">
                    <div class="Homslbox">
                      <div class="Homslt">Total Transactions</div>
                      <div class="Homslc">
                        {{ Number(totalTxCount).toLocaleString() }} ({{
                          currentTPS
                        }}TPS)
                      </div>
                    </div>
                  </div>
                  <div class="Hombox_sr">
                    <!-- <div class="hombottn" @click="dianji">
                      <div>{{ itemname }}</div>
                      <img :src="ImgUrl" />
                    </div> -->
                    <div class="headcontent" id="datalist" v-show="valShow">
                      <ul v-for="(item, index) in calendarDatas" :key="index">
                        <li
                          @click="shuaixuan(item)"
                          :class="index == itemindex ? 'active' : ''"
                        >
                          {{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="Hombox_xia">
                  <div class="Hombox_xl">
                    <div class="Homslbox">
                      <div class="Homslt">Peak TPS (24H)</div>
                      <div class="Homslc">{{ peakTPS }}</div>
                    </div>
                    <div class="Homslbox">
                      <div class="Homslt">Current Gas</div>
                      <div class="Homslc">{{ currentGas }}</div>
                    </div>
                  </div>
                  <!-- <IndexChart :Stakednums="Stakednums" :dayalla="dayalla"></IndexChart> -->
                  <div class="Hombox_xr">
                    <div class="charts">
                      <div
                        id="charts"
                        ref="chartaa"
                        style="width: 503px; height: 103px"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Homrightbox">
                <div class="Hombox_shang">
                  <div class="Hombox_sl">
                    <div class="Homslbox">
                      <div class="Homslt">Total Staked</div>
                      <div class="Homslc">
                        {{ Number(Stakednum).toLocaleString() }}TTOS
                      </div>
                    </div>
                  </div>
                  <div class="Hombox_sr">
                    <!-- <div class="hombottn" @click="dianji">
                      <div>{{ itemname }}</div>
                      <img :src="ImgUrl" />
                    </div> -->
                    <div class="headcontent" id="datalist" v-show="valShow">
                      <ul v-for="(item, index) in calendarDatas" :key="index">
                        <li
                          @click="shuaixuan(item)"
                          :class="index == itemindex ? 'active' : ''"
                        >
                          {{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="Hombox_xia">
                  <div class="Hombox_xl">
                    <div class="Homslbox">
                      <div class="Homslt">Staking Rate</div>
                      <div class="Homslc">{{ stakingRate }} %</div>
                    </div>
                    <div class="Homslbox">
                      <div class="Homslt">
                        Current APY
                        <el-tooltip
                          placement="right"
                          popper-class="toolTipClass"
                        >
                          <div slot="content">
                            This value represents the current highest Annual<br />
                            Percentage Yield (APY), with the APY for each<br />
                            validator determined based on its own workload<br />
                            value. Specifically, 80% of the annual rewards
                            will<br />
                            be directly allocated to delegators, while the<br />
                            remaining 20% will be paid to nodes in the form
                            of<br />
                            commissions.<br />
                            <!-- This is the annual staking delegation reward for<br />
                            TTOS , where 80% of the annual reward will
                            directly<br />
                            belong to the delegator, and the remaining 20%
                            will<br />
                            be paid as commission to the node. -->
                            <!-- This is the annualized return on investment for<br />
                            staking TTOS. Of the total, 80% of the<br />
                            annualized return will directly belong to
                            <br />investors, while the remaining 20% will be
                            paid<br />
                            as commission to the nodes. -->
                          </div>
                          <img src="../../assets/pc/Index/tip.png" />
                        </el-tooltip>
                        <!-- <img src="../../assets/pc/Index/tip.png" /> -->
                      </div>
                      <div class="Homslc">{{ currentAPR }} %</div>
                    </div>
                  </div>
                  <div class="Hombox_xr">
                    <div class="charts">
                      <div
                        id="charts"
                        ref="chartbb"
                        style="width: 503px; height: 103px"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="swiper">
            <div class="Home_swiper-P">
              <p class="clearfix">
                <span>Latest Blocks</span>
                <span
                  ><button @click="More">
                    More <i class="iconfont">&#xe60f;</i>
                  </button></span
                >
              </p>
            </div>
            <div class="Home_swiper_Ul">
              <ul>
                <li
                  v-for="(item, index) in latestBlock.slice(0, 4)"
                  :key="item.blockHash"
                  :class="item.class == 'active' ? 'active' : ''"
                  ref="Acti"
                >
                  <div class="yinchang">
                    <p classt="clearfix">
                      <router-link
                        :to="{
                          name: 'BkHeight',
                          query: { height: item.height },
                        }"
                      >
                        <span>{{ item.height }}</span>
                      </router-link>
                      <span
                        class="notranslate"
                        style="display: flex"
                        @click="BkDetail(item.packer)"
                      >
                        <span style="font-size: 12px; margin-left: 10px"
                          >Packer</span
                        >
                        <span
                          style="
                            display: inline-block;
                            width: 50px;
                            text-align: left;
                            margin-left: 6px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                          "
                          >{{ item.packerName }}</span
                        >
                        <!-- <span class="name notranslate" style="display: inline-block;width:60px; text-align: left; overflow:hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          -o-text-overflow:ellipsis;">{{
                          item.packerName
                        }}...</span
                        > -->
                        <img
                          class="nameimg"
                          src="../../assets/pc/Index/more.png"
                        />
                        <!-- {{ item.gas }} TTOS -->
                        <!-- <span class="Fee"
                          >Gas<i class="iconfont">&#xe600;</i></span
                        > -->
                      </span>
                    </p>
                    <p>
                      <span class="block-time-span">{{ item.tradeTime }}</span>

                      <span>{{ item.tradeNums }} Txns</span>
                    </p>
                    <p>
                      <span>Block Hash</span
                      ><span @click="BkHash(index)">{{ item.blockHash }}</span>
                    </p>
                    <p>
                      <span
                        ><img
                          class="hotimg"
                          src="../../assets/pc/Index/hot.png"
                        />{{ item.gas }} TTOS</span
                      >
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="Letest">
            <div class="Home_letest">
              <div class="clearfix Home_LetestT">
                <div class="Home_LetestT_trans">
                  <span>Latest Transactions</span>
                  <span @click="More1"
                    >More <img src="@/assets/pc/HomeTop/jantou.svg" alt=""
                  /></span>
                </div>
                <div class="myswiper-container scroll">
                  <div>
                    <div
                      v-for="(item, index) in lastTranstion.slice(0, 10)"
                      :key="item.txHash"
                    >
                      <div
                        class="Home_Swiper_all"
                        :class="item.class == 'active' ? 'fadenum1' : ' '"
                      >
                        <div class="Home-swiper_p">
                          <div class="Home-swiper_P1">
                            <div class="Home-swiper_P2">
                              <p @click="To(index)">{{ item.txHash1 }}</p>
                              <p class="block-time-span1 black">
                                {{ Time2[index] }}
                              </p>
                            </div>
                            <div class="Home-swiper_P3">
                              <p>
                                <span> From </span>
                                <span
                                  @click="BkDetail(item.fromAddress)"
                                  v-if="
                                    item.type != 'Unstake' &&
                                    item.fromAddress != 'Unpledge'
                                  "
                                  >{{ item.fromAddress }}</span
                                >

                                <span class="FromActive" v-else
                                  >&nbsp;Unstake</span
                                >
                              </p>
                              <p>
                                <span> To </span>
                                <span
                                  style="color: #8d8d8d"
                                  v-if="
                                    item.type == 'ContractCreation' ||
                                    item.type == 'setBaseTokenURI' ||
                                    item.functions == 'balanceOf' ||
                                    item.functions == 'Contract Execute'
                                  "
                                  >...</span
                                >
                                <!-- <span
                                  @click="BkDetail(item.toAddress)"
                                  v-if="
                                    item.type =='Stake' ||
                                      item.toAddress =='Stake'
                                   
                                  "
                                >
                                Stake
                                </span> -->
                                <span
                                  @click="BkDetail(item.toAddress)"
                                  v-if="
                                    item.type != 'Stake' &&
                                    item.toAddress != 'Stake'
                                  "
                                >
                                  {{ item.toAddress }}
                                </span>
                                <span
                                  style="color: #8d8d8d; margin-left: 4px"
                                  v-if="
                                    item.type == 'Stake' &&
                                    item.toAddress == 'Stake'
                                  "
                                  >Stake</span
                                >

                                <!-- <span  style="color:#8d8d8d;margin-left: 4px;"  v-if="item.toAddress=='Pledge'">Stake</span> -->
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="Home-swiper_p1 Home-swiper_p4">
                          <p
                            v-if="
                              item.type1 == 1 ||
                              item.type1 == 2 ||
                              item.type1 == 3 ||
                              item.type1 == 4 ||
                              item.type1 == 5 ||
                              item.type1 == 'to' ||
                              item.type1 == 'from' ||
                              item.type1 == 'toAward' ||
                              item.type1 == 'commission' ||
                              item.type1 == 99
                            "
                            style="width: 129px; padding-left: 0px"
                          >
                            <!-- {{
                              new Intl.NumberFormat("en-US", {
                                minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                                maximumFractionDigits: 10,
                              }).format()
                            }} -->
                            {{ item.amount }}
                            TTOS
                            <!-- {{ Number(item.amount).toLocaleString() }} TTOS -->
                          </p>

                          <p
                            v-if="
                              item.type1 == '8' &&
                              item.standard == 'ERC-20' &&
                              item.type !== 'balanceOf'
                            "
                          >
                            <!-- <span v-if="item.tokenAmount.length>8"> {{ item.tokenAmount}}... </span>
                            <span v-else>{{ Number(item.tokenAmount).toLocaleString() }} </span>     -->
                            {{ item.tokenAmount }}
                            <!-- aaa{{ Number(item.tokenAmount).toLocaleString() }} -->
                            {{ item.symbol }}
                          </p>
                          <p
                            v-if="
                              (item.type1 == '8' &&
                                item.standard == 'ERC-721') ||
                              item.functions !== 'balanceOf' ||
                              item.type !== 'setBaseTokenURI'
                            "
                          >
                            {{ item.nftNameList }}
                            <!-- <span v-if="item.tokenAmount!==''|| item.tokenAmount!==null">{{ item.tokenAmount.split(",")[0] }}</span> -->
                            <!-- {{ item.tokenAmount.split(",")[0] }} -->
                          </p>

                          <p
                            v-if="
                              (item.type1 == '8' &&
                                item.standard == 'ERC-721' &&
                                item.type == 'setBaseTokenURI') ||
                              item.functions == 'balanceOf'
                            "
                          >
                            {{ item.symbol }}
                            <!-- <span v-if="item.typ=='mint'">       333 {{ item.contractName }}</span>
                       
                            <span v-else>222 {{ item.symbol }} </span> -->
                          </p>
                          <!-- <p v-else>
                           333 {{ item.contractName }}
                          </p> -->

                          <p
                            v-if="
                              item.type1 == '7' && item.standard == 'ERC-20'
                            "
                          >
                            {{ item.symbol }}
                          </p>
                          <p
                            v-if="
                              item.standard == 'ERC-721' && item.type1 == '7'
                            "
                          >
                            {{ item.symbol }}
                          </p>
                          <div class="buttons">{{ item.type }}</div>
                          <span
                            >Amount
                            <i class="iconfont">&#xe600;</i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Home_Letest_Ul">
                <div class="index_content">
                  <div class="indexChart">
                    <div class="indexChart-item">
                      <img
                        src="../../assets/pc/Index/map.png"
                        id="imgs"
                        style="
                          width: 502px;
                          height: 297px;
                          margin-top: 14px;
                          margin-left: 28px;
                        "
                      />
                      <!-- <div class="indexChart-title">Validators Status</div> -->
                      <div class="barsBox">
                        <div id="bars"></div>
                        <div class="barflex">
                          <div class="barnum">
                            <!-- cityCount: 0,
                            nationCount: 0,
                            validatorCount: 0, -->
                            <span>{{ validatorCounts }}</span
                            ><span>Validators</span>
                          </div>
                          <div class="barnum">
                            <span>{{ nationCount }}</span
                            ><span>Countries</span>
                          </div>
                          <div class="barnum">
                            <span>{{ cityCount }}</span
                            ><span>Cities</span>
                          </div>
                        </div>
                        <div class="barfoot">
                          <div class="barfootit">Current Packer</div>
                          <!-- <marquee> -->
                          <div class="barfootlist">
                            <div class="barmquee">
                              <div
                                v-for="(item, index) in latestPackers.slice(
                                  0,
                                  14
                                )"
                                :key="index"
                                :class="
                                  item.class == 'activea'
                                    ? 'list barfli'
                                    : 'barfli'
                                "
                              >
                                <img :src="item.packerLogo" />
                                <span
                                  style="cursor: pointer"
                                  @click="BkDetail(item.packer)"
                                  >{{ item.packerName }}</span
                                >
                              </div>
                            </div>
                          </div>
                          <!-- </marquee> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chart_list">
            <div class="chart_box">
              <div class="chart_shang">
                <div class="chart_sleft">TTOS Supply & Staking</div>
                <div class="chart_sright">
                  <!-- <div class="hombottn" @click="dianjia(1)">
                    <div>{{ itemname }}</div>
                    <img :src="ImgUrl" />
                  </div> -->
                  <div class="headcontent" id="datalist" v-show="valShowa">
                    <ul v-for="(item, index) in calendarDatas" :key="index">
                      <li
                        @click="shuaixuana(item, 1)"
                        :class="index == itemindex ? 'active' : ''"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="chart_xia">
                <div class="chart_xleft">
                  <div class="chart_xbox">
                    <div class="chart_title">TTOS Supply</div>
                    <div class="chart_content">
                      <div class="chart_num">
                        {{ Number(currentSupply).toLocaleString() }}
                      </div>
                      <div class="chart_butttn">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="Yesterday's New Addition Percentage"
                          placement="top-start"
                        >
                          <span>{{ last24hSupplyPercent }}</span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="chart_xbox">
                    <div class="chart_title">Total Staked</div>
                    <div class="chart_content">
                      <div class="chart_num">
                        {{ Number(Stakednum).toLocaleString() }}
                      </div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Yesterday's New Addition Percentage"
                        placement="top-start"
                      >
                        <div class="chart_butttn charcolor">{{ Stakedb }}%</div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="chart_xright">
                  <div
                    class="charts"
                    style="width: 940px; height: 161px"
                    ref="charta"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="chart_list" style="margin-top: 20px">
            <div class="chart_box">
              <div class="chart_shang">
                <div class="chart_sleft">Bonus & Burned</div>
                <div class="chart_sright">
                  <!-- <div class="hombottn" @click="dianjia(2)">
                    <div>{{ itemnamea }}</div>
                    <img :src="ImgUrl" />
                  </div> -->
                  <div class="headcontent" id="datalist" v-show="valShowb">
                    <ul v-for="(item, index) in calendarDatas" :key="index">
                      <li
                        @click="shuaixuana(item, 2)"
                        :class="index == itemindex ? 'active' : ''"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="chart_xia">
                <div class="chart_xleft">
                  <div class="chart_xbox">
                    <div class="chart_title">Total Bonus</div>
                    <div class="chart_content">
                      <div class="chart_num">
                        {{ Number(currentBonus).toLocaleString() }}
                      </div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Yesterday's New Addition Percentage"
                        placement="top-start"
                      >
                        <div class="chart_butttn">{{ Bonusb }}%</div>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="chart_xbox">
                    <div class="chart_title">Total Burned</div>
                    <div class="chart_content">
                      <div class="chart_num">
                        {{ Number(currentBurn).toLocaleString() }}
                      </div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Yesterday's New Addition Percentage"
                        placement="top-start"
                      >
                        <div class="chart_butttn charcolor">{{ Burnb }}%</div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="chart_xright" style="margin-left: 34px">
                  <div
                    class="charts"
                    style="width: 940px; height: 161px"
                    ref="chartb"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <VerifyNode :flag="flags" @none="none($event)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import { goPAGE, formatSeconds, listType, getSubStr } from "@/utils/utils";
import Homeinput from "./Home/Home_input";
import TimeBox from "@/components/pc/Timebox.vue";
import IndexChart from "@/components/pc/Indexcharts.vue";
import IndexChartB from "@/components/pc/Indexchartsb.vue";
import HomeTop from "./Home/Home_Top";
import VerifyNode from "./Home/VerifyNode.vue";
import { GetHomeData, GetHomePastTradeData } from "@/assets/server/api";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

import dot from "@/assets/pc/Index/map.png";
const echarts = require("echarts");
export default {
  data() {
    return {
      // 开始
      IsShow: false,
      valShow: false,
      valShowa: false,
      valShowb: false,
      itemindex: 0,
      itemname: "1M",
      itemnamea: "1M",
      ImgUrl: require("@/assets/pc/seach/xia.png"),
      calendarDatas: [
        {
          name: "1M",
          value: 30,
          id: 0,
        },
        {
          name: "6M",
          value: 180,
          id: 1,
        },
        {
          name: "1Y",
          value: 365,
          id: 2,
        },
        {
          name: "ALL",
          value: 5000,
          id: 3,
        },
      ],
      // 结束
      LogoImg: require("@/assets/pc/Index/indexlogo.png"),
      imgurl: require("@/assets/pc/Index/vers.png"),
      latestBlock: [],
      mapCityArr: [],
      latestTranstion: [],
      pastTradesList: "",
      verifyList: [],
      list: [],
      list2: [],
      Address2: [],
      txHash2: [],
      xAxis: [],
      pastdays: [],
      YueRi: [],
      quxian: [],
      timer: null,
      timer2: null,
      timerall: null,
      timerall2: null,
      interal: "",
      Time3: [],
      Time2: [],
      Time1: [],
      newData: [],
      newData1: [],
      newData2: [],
      flags: false,
      gMapData1: [],
      gMapDataa: [],
      ditudata: [],
      ditudatb: [],
      strdatestart: "",
      strdateend: "",
      shijiancha: "",
      tpsCount: 0,
      // 倒计时开始
      // nextDuring: "", //倒计时
      theTime: 0, // 秒
      theTime1: 0, // 分
      theTime2: 0, // 时
      percentage: "", //进度条倒计时
      // 倒计时结束
      // allNodes: 0,
      // validators: 0,
      //  maxGas: 0,
      maxGas1: [],
      // totalFlux: 0,
      // sendTimeoutObj: "",
      // totalTxCount: "",
      duration: 3000,
      // startVal: 0,
      // endVal: 0,
      // messageId: [],
      // startValarr: [],
      lockReconnect: false,
      timeout: 15 * 1000,
      timeoutObj: null,
      serverTimeoutObj: null,
      timeoutnum: null,
      myChart: "",
      //首页接口开始
      currentHeight: "", //当前高度
      last24hHeight: "", //过去24小时增长的高度
      activeToday: "", //当天活跃数
      totalAccounts: "", //总账户数

      nodeCount: 2, //节点数量
      pastBurn: "", //昨天的销毁量
      pastSupply: "", // 昨天的供应量
      validatorCount: 0, // 验证器数量
      nextDuring: 0, //下一个纪元期

      //latestBlock
      latestBlock: [],
      //最新交易开始
      lastTranstion: [],
      //首页上方交易数图表和质押图表
      currentTPS: 0,
      totalTxCount: 0, // 交易总数
      peakTPS: "0", //24小时最大TPS
      currentGas: "0", //当前GAS
      totalStaked: "", // 总质押数
      stakingRate: "", //质押率
      currentAPR: "", //当前年利率
      dayalla: [],
      Transactionsnums: [],
      dayallb: [],
      Stakednums: [],
      pastdays: 30, //默认曲线图传参30,180,365,5000
      //首页最下方的曲线图片
      Supplynum: "",
      Supplynumf: "",
      Stakednum: "",
      Stakednumf: "",
      daysx: [],
      Supplynumarr: [],
      Stakednumarr: [],
      Burnednum: "",
      Burnednumf: "",
      Bonusnum: "",
      Bonusnumf: "",
      Burnednumarr: [],
      Bonusnumarr: [],
      //首页接口结束
      //首页地图开始

      cityCount: 0,
      nationCount: 0,
      validatorCounts: 0,
      latestPackers: [], //打包者
      PackerList: [],
      cityNationArr: [], //地图上的点
      baifenb: "",
      Supplyb: "",
      Stakedb: "",
      Bonusb: "",
      Burnb: "",
      //首页地图结束
      pastBurn24: "",
      currentBurn: "",
      pastBurn: "",
      currentSupply: "",
      pastSupply: "",
      pastStaked: "",
      totalStaked: "",
      currentBonus: "",
      pastBonus: "",
      pastOneDayBonus: "",
      pastTwoDayBonus: "",
      pastOneDayBurn: "",
      pastTwoDayBurn: "",
      last24hBurn: "",
      last24hSupplyPercent: "",
    };
  },
  components: {
    HomeTop,
    Homeinput,
    Swiper,
    SwiperSlide,
    VerifyNode,
    countTo,
    TimeBox,
    IndexChart,
    IndexChartB,
  },
  watch: {
    deep: true,
    verifyList(val) {
      var txHash1 = [];
      for (let i = 0; i < val.length; i++) {
        txHash1[i] = getSubStr(val[i].txHash, 0, 6);
        this.txHash2 = txHash1;
      }
    },
  },
  computed: {},
  created() {
    this.initWebSocket();
  },
  mounted() {
    this.HomeList();
    this.HomeCharts();
    this.barsChartFun();
    this.shijian();
  },
  beforeDestroy() {
    // 实例销毁前 清空实例
    this.myChart = null;
    // 解绑屏幕监听事件
    window.removeEventListener("resize", this.resize, false);
  },
  destroyed() {
    ///  this.websock.close();
    this.$router.go(0);
    clearInterval(this.Time);
  },
  methods: {
    recordsChange(val) {
      this.nextDuring = val;
    },
    initChartsa() {
      this.lineChart = echarts.init(this.$refs.charta);
      let option = {
        color: ["#80FFA5", "#00DDFF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            //  console.log(params);
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>TTOS Sypply:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              Number(params[1].value).toLocaleString() +
              "</span>" +
              "</div>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Total TTOS Staked:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              Number(params[0].value).toLocaleString() +
              "</span>" +
              "</div>";
            return str;
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.daysx,
            show: false,
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            // min:10000,
            // min:0,
            // max: 70,007,055.44,
            axisTick: {
              show: false, //刻度线
            },
            axisLine: {
              show: true, //隐藏y轴
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },

            splitNumber: 2,
            boundaryGap: false,
            show: true,

            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#A5BF4D",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#A5BF4D",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            areaStyle: {
              // opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 231, 154, 1, [
                {
                  offset: 0,
                  // color:"red"
                  color: "rgba(72, 83, 32,100)",
                },
                {
                  offset: 1,
                  // color:"yellow"
                  color: "rgb(10, 12,4, 100)",
                },
              ]),
            },
            data: this.Stakednumarr,
            // data: this.Supplynumarr,
          },
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#00E79A",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            showSymbol: false,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(3, 70, 48,100)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 13, 9,100)",
                },
              ]),
            },
            data: this.Supplynumarr,
            //  data: this.Stakednumarr,
          },
        ],
      };
      this.lineChart.clear();
      this.lineChart.setOption(option);
    },
    initChartsb() {
      this.lineChart = echarts.init(this.$refs.chartb);
      let option = {
        color: ["#80FFA5", "#00DDFF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            //   console.log(params);
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>TTOS Bonus :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              Number(params[1].value).toLocaleString() +
              "</span>" +
              "</div>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background: #D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Total TTOS Burned :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              Number(params[0].value).toLocaleString() +
              "</span>" +
              "</div>";

            return str;
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            data: this.daysx,
            show: false,
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisTick: {
              show: false, //刻度线
            },
            axisLine: {
              show: false, //隐藏y轴
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
            boundaryGap: false,
            show: false,
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#A5BF4D",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#A5BF4D",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            areaStyle: {
              // opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 231, 154, 1, [
                {
                  offset: 0,
                  color: "rgba(72, 83, 32,100)",
                },
                {
                  offset: 1,
                  color: "rgb(10, 12,4, 100)",
                },
              ]),
            },
            data: this.Bonusnumarr,
            // data: [120, 282, 131, 434, 220, 340, 310],
          },
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#00E79A",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            showSymbol: false,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(3, 70, 48,100)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 13, 9,100)",
                },
              ]),
            },
            // data: [140, 232, 101, 264, 90, 340, 250],
            data: this.Burnednumarr,
          },
        ],
      };

      this.lineChart.clear();
      this.lineChart.setOption(option);
    },
    initChartsaa() {
      this.lineChart = echarts.init(this.$refs.chartaa);
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Transactions:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              Number(params[0].value).toLocaleString() +
              "</span>" +
              "</div>";
            return str;
          },
        },
        grid: {
          top: "6%",
          left: "1%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: false,
          data: this.dayalla,
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#00E79A",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          axisTick: {
            show: false, //刻度线
          },
          axisLine: {
            show: false, //隐藏y轴
          },
          axisLabel: {
            show: false, //隐藏刻度值
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },

          boundaryGap: false,
          show: false,

          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(0, 231, 154, 50)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: this.Transactionsnums,
          },
        ],
      };
      this.lineChart.clear();
      this.lineChart.setOption(option);
    },
    initChartsbb() {
      this.lineChart = echarts.init(this.$refs.chartbb);
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Staked :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              Number(params[0].value).toLocaleString() +
              "</span>" +
              "</div>";
            return str;
          },
        },
        grid: {
          top: "6%",
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: false,
          data: this.dayalla,
        },
        yAxis: {
          type: "value",
          show: false,
          min: 0,
          axisTick: {
            show: false, //刻度线
          },
          axisLine: {
            show: false, //隐藏y轴
          },
          axisLabel: {
            show: false, //隐藏刻度值
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          boundaryGap: false,
          show: false,
          splitLine: {
            show: false,
          },
        },
        //data: [820, 932, 901, 934, 1290, 1330, 1320],
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(211, 248, 90, 40)", //折线颜色
              // 241, 244, 255, 1
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: this.Stakednums,
          },
        ],
      };
      this.lineChart.clear();
      this.lineChart.setOption(option);
    },
    dianji() {},
    dianjia(value) {
      //  console.log(value);
      if (value == 1) {
        if (this.IsShow == false) {
          this.IsShow = true;
          this.valShowa = true;
          this.ImgUrl = require("@/assets/pc/seach/shang.png");
        } else if (this.IsShow == true) {
          this.IsShow = false;
          this.valShowa = false;
          this.ImgUrl = require("@/assets/pc/seach/xia.png");
        }
      }
      if (value == 2) {
        if (this.IsShow == false) {
          this.IsShow = true;
          this.valShowb = true;
          this.ImgUrl = require("@/assets/pc/seach/shang.png");
        } else if (this.IsShow == true) {
          this.IsShow = false;
          this.valShowb = false;
          this.ImgUrl = require("@/assets/pc/seach/xia.png");
        }
      }
    },
    shuaixuan() {},
    async shuaixuana(itemvalue, value) {
      // console.log(itemvalue);
      //  console.log(value);
      if (value == 1) {
        this.itemindex = itemvalue.id;
        this.valShowa = false;
        this.IsShow = false;
        this.itemname = itemvalue.name;
        this.pastdays = itemvalue.value;
      } else if (value == 2) {
        this.itemindex = itemvalue.id;
        this.valShowb = false;
        this.IsShow = false;
        this.itemnamea = itemvalue.name;
        this.pastdays = itemvalue.value;
      }

      let formData = new FormData();
      let params = {
        pastdays: this.pastdays,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetHomePastTradeData(formData);
      // console.log(data);
      for (var i = 0; i < data.result.length; i++) {
        //   Supplynum:"",
        // Stakednum:"",
        var lengths = data.result.length - 1;
        //console.log(lengths);
        this.Supplynum = data.result[lengths].totalSupply;
        //    console.log(this.Supplynum);
        this.Stakednum = data.result[lengths].totalStaked;
        this.Supplynumarr.push(data.result[i].totalSupply);
        this.Stakednumarr.push(data.result[i].totalStaked);
        this.daysx.push(data.result[i].pastdays);
        this.initChartsa();
      }
    },
    shuaixuanb(itemvalue) {
      console.log(itemvalue);
    },
    async HomeList() {
      let data = await GetHomeData();
      //  console.log(data);
      //首页第一部分开始
      this.last24hSupplyPercent = data.result.last24hSupplyPercent;
      if (this.last24hSupplyPercent > 0) {
        this.last24hSupplyPercent = "+" + this.last24hSupplyPercent;
      }
      this.currentHeight = data.result.currentHeight;
      this.last24hHeight = data.result.last24hHeight;
      this.totalAccounts = data.result.totalAccounts;
      //   console.log(this.totalAccounts);
      this.activeToday = data.result.activeToday;
      //    console.log(this.activeToday);
      this.currentSupply = data.result.currentSupply;
      //    console.log(this.currentSupply);
      this.pastSupply = data.result.pastSupply;
      //    console.log(this.pastSupply);
      //    console.log(parseFloat(this.currentSupply) - parseFloat(this.pastSupply));
      //    console.log(70003431.92 / parseFloat(this.pastSupply));
      this.baifenb = (
        ((parseFloat(this.currentSupply) - parseFloat(this.pastSupply)) /
          parseFloat(this.pastSupply)) *
        100
      ).toFixed(6);
      // this.baifenb = data.result.last24hSupplyPercent;
      //    console.log(this.baifenb);
      // if (this.baifenb == "Infinity") {
      //   this.baifenb = 0;
      // }
      this.currentBurn = data.result.currentBurn;
      //    console.log(this.currentBurn);
      this.pastBurn = data.result.pastBurn;
      //    console.log(this.pastBurn);
      //  this.pastBurn24=(parseFloat(this.currentBurn)-parseFloat(this.pastBurn)).toFixed(3);
      //  console.log( this.pastBurn24);

      //  this.Burnb=((parseFloat(this.currentBurn)-parseFloat(this.pastBurn))/(parseFloat(this.pastBurn))*100).toFixed(3);
      //     console.log(this.pastBurn);
      this.pastStaked = data.result.pastStaked;
      //    console.log(this.pastStaked);
      this.totalStaked = data.result.totalStaked;
      //     console.log(this.totalStaked);
      // this.Stakedb = (
      //   ((parseFloat(this.pastStaked) - parseFloat(this.totalStaked)) /
      //     parseFloat(this.totalStaked)) *
      //   100
      // ).toFixed(3);
      this.Stakedb = parseFloat(data.result.last24hStakePercent);
      //    console.log(this.Stakedb);
      //    console.log(this.totalStaked);
      this.currentBonus = parseFloat(data.result.currentBonus).toFixed(3);
      //    console.log(this.currentBonus);
      this.pastBonus = data.result.pastBonus;
      //    console.log(this.pastBonus);
      //  this.Bonusb=((parseFloat(this.currentBonus)-parseFloat(this.pastBonus))/(parseFloat(this.pastBonus))*100).toFixed(3);
      this.pastOneDayBonus = data.result.pastOneDayBonus;
      this.pastTwoDayBonus = data.result.pastTwoDayBonus;
      this.pastOneDayBurn = data.result.pastOneDayBurn;
      //     console.log(this.pastOneDayBurn);
      this.pastTwoDayBurn = data.result.pastTwoDayBurn;
      this.last24hBurn = data.result.last24hBurn;
      //     console.log(this.pastTwoDayBurn);
      // this.pastBurn24=((parseFloat(this.pastOneDayBonus)-(parseFloat(this.pastTwoDayBonus));
      this.pastBurn24 = (
        parseFloat(this.pastOneDayBurn) - parseFloat(this.pastTwoDayBurn)
      ).toFixed(3);
      //     console.log(this.pastBurn24);
      // this.Bonusb = (
      //   ((parseFloat(this.pastOneDayBonus) - parseFloat(this.pastTwoDayBonus)) /
      //     parseFloat(this.pastTwoDayBonus)) *
      //   100
      // ).toFixed(3);
      this.Bonusb = parseFloat(data.result.last24hBonusPercent).toFixed(3);
      this.Burnb = parseFloat(data.result.last24hBurnPercent).toFixed(3);
      // this.Burnb = (
      //   ((parseFloat(this.pastOneDayBurn) - parseFloat(this.pastTwoDayBurn)) /
      //     parseFloat(this.pastTwoDayBurn)) *
      //   100
      // ).toFixed(3);
      this.nextDuring = data.result.nextDuring / 1000;
      //    console.log(this.nextDuring);

      this.validatorCount = data.result.validatorCount;
      this.nodeCount = data.result.nodeCount;

      //首页第一部分结束
      //Latest Blocks最新区块开始
      this.latestBlock = data.result.latestBlockList;
      //     console.log(this.latestBlock);
      let strdate = Math.floor(data.result.linuxTime / 1000);
      for (let i = 0; i < this.latestBlock.length; i++) {
        if (
          this.latestBlock[i].packerName === "" ||
          this.latestBlock[i].packerName == null
        ) {
          this.latestBlock[i].packerName = getSubStr(
            this.latestBlock[i].packer,
            0,
            8
          );
        } else {
          this.latestBlock[i].packerName = this.latestBlock[i].packerName;
        }
        let timestampss = Math.floor(this.latestBlock[i].blockTime / 1000);
        let s = strdate - timestampss;
        if (s <= 0) {
          s = 1;
        }
        this.latestBlock[i].tradeTime = formatSeconds(s);
        this.newData.push(s);
      }

      //Latest Blocks结束
      //Latest Transactions最新交易开始
      this.lastTranstion = data.result.latestTxList;
      //  console.log(this.lastTranstion);
      for (let i = 0; i < this.lastTranstion.length; i++) {
        if (this.lastTranstion[i].toAddress == "Pledge") {
          this.lastTranstion[i].toAddress = "Stake";
        }
        if (this.lastTranstion[i].toAddress == "") {
          this.lastTranstion[i].toAddress = "...";
        }

        this.lastTranstion[i].txHash1 = getSubStr(
          this.lastTranstion[i].txHash,
          0,
          6
        );
        let timestamps = Math.floor(this.lastTranstion[i].tradeTime / 1000);
        let ss = strdate - timestamps;
        if (ss <= 0) {
          ss = 1;
        }
        this.Time2[i] = formatSeconds(ss);
        this.newData1.push(ss);
        this.lastTranstion[i].type1 = this.lastTranstion[i].type;
        if (this.lastTranstion[i].type1 == 8) {
          this.lastTranstion[i].type = this.lastTranstion[i].functions;
          this.lastTranstion[i].toAddress = this.lastTranstion[i].toEvmAddress;
          this.lastTranstion[i].fromAddress =
            this.lastTranstion[i].fromEvmAddress;
        }

        this.lastTranstion[i].type = listType(this.lastTranstion[i].type);
        if (
          this.lastTranstion[i].type1 == 8 &&
          this.lastTranstion[i].standard == "ERC-721" &&
          this.lastTranstion[i].functions == "setBaseTokenURI"
        ) {
          this.lastTranstion[i].symbol = this.lastTranstion[i].contractName;
        }

        if (this.lastTranstion[i].nftNameList !== "") {
          this.lastTranstion[i].nftNameList = JSON.parse(
            this.lastTranstion[i].nftNameList
          )[0];
          this.lastTranstion[i].symbol = "";
        } else {
          // 新加的内容
          if (
            this.lastTranstion[i].type1 == 8 &&
            this.lastTranstion[i].standard == "ERC-721"
          ) {
            if (this.lastTranstion[i].contractName !== "") {
              this.lastTranstion[i].nftNameList =
                this.lastTranstion[i].contractName;
            } else {
              //this.lastTranstion[i].nftNameList = getSubStr(this.lastTranstion[i].contractAddress,0,3);
              this.lastTranstion[i].nftNameList =
                this.lastTranstion[i].tokenAmount;
            }
          }
          // this.lastTranstion[i].symbol=''
        }
        //      console.log(this.lastTranstion);
        if (
          this.lastTranstion[i].type == "transferFrom" &&
          this.lastTranstion[i].nftNameList == ""
        ) {
          this.lastTranstion[i].nftNameList =
            this.lastTranstion[i].contractName;
        }
        //mint铸造当合约名字为空
        if (
          this.lastTranstion[i].functions == "mint" &&
          this.lastTranstion[i].nftNameList == ""
        ) {
          this.lastTranstion[i].nftNameList = this.lastTranstion[i].tokenAmount;
        }
        if (
          this.lastTranstion[i].type == "setBaseTokenURI" &&
          this.lastTranstion[i].nftNameList !== ""
        ) {
          this.lastTranstion[i].nftNameList = "";
        }
        // else if(this.lastTranstion[i].type == "transferFrom"  &&
        //   this.lastTranstion[i].nftNameList !== ""){
        //     this.lastTranstion[i].nftNameList=this.lastTranstion[i].nftNameList;
        //   }
        if (
          this.lastTranstion[i].type1 == 8 &&
          this.lastTranstion[i].standard == "ERC-20"
        ) {
          if (this.lastTranstion[i].tokenAmount !== "") {
            if (this.lastTranstion[i].tokenAmount.length > 8) {
              this.lastTranstion[i].tokenAmount =
                Number(this.lastTranstion[i].tokenAmount.slice(0, 8)) + "...";
              // this.lastTranstion[i].tokenAmount =this.lastTranstion[i].tokenAmount.slice(0,8)+'...';
            } else {
              this.lastTranstion[i].tokenAmount =
                this.lastTranstion[i].tokenAmount;
            }
          }
        }

        if (
          this.lastTranstion[i].type1 == 7 &&
          this.lastTranstion[i].standard == "ERC-20"
        ) {
          if (this.lastTranstion[i].tokenAmount !== "") {
            if (this.lastTranstion[i].tokenAmount.length > 8) {
              this.lastTranstion[i].tokenAmount =
                this.lastTranstion[i].tokenAmount.slice(0, 8) + "...";
            } else {
              this.lastTranstion[i].tokenAmount =
                this.lastTranstion[i].tokenAmount;
            }
          }
          if (this.lastTranstion[i].symbol !== "") {
            this.lastTranstion[i].symbol = this.lastTranstion[i].symbol;
          } else {
            if (this.lastTranstion[i].contractName.trim() !== "") {
              this.lastTranstion[i].symbol = this.lastTranstion[i].contractName;
            } else {
              this.lastTranstion[i].symbol = getSubStr(
                this.lastTranstion[i].contractAddress,
                0,
                3
              );
            }
          }
          //     if(this.lastTranstion[i].contractName.trim() !=='' ){
          //       if(this.lastTranstion[i].symbol.trim() !==''){
          //         this.lastTranstion[i].symbol =this.lastTranstion[i].symbol;
          //       }else{
          //          this.lastTranstion[i].symbol = this.lastTranstion[i].contractName;
          //            }
          // }
          //     else{
          //      // console.log(2222);
          //     //  this.lastTranstion[i].symbol = getSubStr(this.lastTranstion[i].contractAddress,0,3);
          //     }
          //console.log(123);
        }
        if (
          this.lastTranstion[i].type1 == 7 &&
          this.lastTranstion[i].standard == "ERC-721"
        ) {
          if (this.lastTranstion[i].contractName !== "") {
            this.lastTranstion[i].symbol = this.lastTranstion[i].contractName;
          } else {
            this.lastTranstion[i].symbol = getSubStr(
              this.lastTranstion[i].contractAddress,
              0,
              3
            );
          }
          //console.log(123);
        }
        // if (this.lastTranstion[i].symbol == "") {
        //   this.lastTranstion[i].symbol = this.lastTranstion[i].contractName;
        // } else {
        //   this.lastTranstion[i].symbol = this.lastTranstion[i].symbol;
        // }
      }
      //Latest Transactions

      //Latest Transactions最新交易结束
      //首页上方交易数图表和质押图表开始
      this.currentTPS = data.result.currentTPS;
      this.totalTxCount = data.result.totalTxCount;
      this.peakTPS = data.result.peakTPS;
      this.currentGas = data.result.currentGas;
      this.totalStaked = data.result.totalStaked;
      this.stakingRate = (data.result.stakingRate * 100).toFixed(3);
      this.currentAPR = (parseFloat(data.result.currentAPR) * 100).toFixed(2);

      for (var m = 0; m < data.result.pastTradeDataList.length; m++) {
        this.dayalla.push(data.result.pastTradeDataList[m].pastTime);
        this.Transactionsnums.push(data.result.pastTradeDataList[m].txCount);
        this.Stakednums.push(data.result.pastTradeDataList[m].totalStaked);
      }
      //   console.log(this.dayalla);
      //   console.log(this.Transactionsnums);
      //   console.log(this.Stakednums);
      this.initChartsaa();
      this.initChartsbb();
      //dayalla
      //首页上方交易数图表和质押图表结束
      //首页地图数据
      //    console.log(data.result.mapData);
      //    console.log(data.result.mapData.cityCount);
      this.cityCount = data.result.mapData.cityCount;
      this.nationCount = data.result.mapData.nationCount;
      this.validatorCounts = data.result.mapData.validatorCount;
      this.latestPackers = data.result.mapData.latestPackers;
      //    console.log(this.latestPackers);
      this.cityNationArr = data.result.mapData.cityNationArr;
      for (var n = 0; n < this.latestPackers.length; n++) {
        if (this.latestPackers[n].packerName == "") {
          this.latestPackers[n].packerName = getSubStr(
            this.latestPackers[n].packer,
            0,
            10
          );
        }
        if (this.latestPackers[n].packerLogo == "") {
          this.latestPackers[n].packerLogo = this.imgurl;
        }
      }
      //     console.log(this.latestPackers);
      //    console.log(this.cityCount);
      this.barsChartFun();
      // cityCount: 0,
      // nationCount: 0,
      // validatorCount: 0,
      //首页地图数据
      // this.totalTxCount = data.result.totalTxCount;
      // this.startVal = this.totalTxCount;
      // this.endVal = this.totalTxCount;
      // this.validators = data.result.validators;
      // this.maxGas = data.result.maxGas;
      //  this.totalFlux = data.result.totalFlux;
      //  this.allNodes = "/ " + data.result.allNodes;
      this.tpsCount = data.result.tpsCount;
      this.daojishi();
    },
    daojishi() {
      this.Time = setInterval(async () => {
        this.nextDuring--;
        this.percentage = (((86400 - this.nextDuring) / 86400) * 100).toFixed(
          1
        );
        this.theTime = parseInt(this.nextDuring); // 需要转换的时间秒
        this.theTime1 = 0; // 分
        this.theTime2 = 0; // 小时
        if (this.theTime > 60) {
          this.theTime1 = parseInt(this.theTime / 60);
          if (this.theTime > 1) {
            this.theTime = parseInt(this.theTime % 60);
          } else {
            this.theTime = 60;
          }
          if (this.theTime1 > 60) {
            this.theTime2 = parseInt(this.theTime1 / 60);
            if (this.theTime1 > 1) {
              this.theTime1 = parseInt(this.theTime1 % 60);
            } else {
              this.theTime1 = 60;
            }
            if (this.theTime2 > 24) {
              //大于24小时
              this.theTime2 = parseInt(this.theTime2 % 24);
            }
          }
        }
      }, 1000);
      //  this.$emit("recordsChange",  this.nextDuring);
    },
    async HomeCharts() {
      let formData = new FormData();
      let params = {
        pastdays: 30,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetHomePastTradeData(formData);
      //     console.log(data);
      for (var i = 0; i < data.result.length; i++) {
        //   Supplynum:"",
        // Stakednum:"",

        var lengths = data.result.length - 1;
     //   console.log(lengths);
        if (lengths > 0) {
          this.Supplynum = data.result[lengths].totalSupply;
          this.Supplynumf = (
            ((data.result[lengths].totalSupply -
              data.result[lengths - 1].totalSupply) /
              data.result[lengths].totalSupply) *
            100
          ).toFixed(6);
        }
        // this.Supplynumf=data.result.last24hSupplyPercent;
        // console.log(this.Supplynumf);
        this.Stakednum = data.result[lengths].totalStaked;
        if (lengths > 0) {
        this.Stakednumf = (
          ((data.result[lengths].totalStaked -
            data.result[lengths - 1].totalStaked) /
            data.result[lengths].totalStaked) *
          100
        ).toFixed(6);
        }
        this.Supplynumarr.push(data.result[i].totalSupply);
        this.Stakednumarr.push(data.result[i].totalStaked);
        this.daysx.push(data.result[i].pastTime);
        this.Burnednum = data.result[lengths].totalBonus;
        if (lengths > 0) {
        this.Burnednumf = (
          ((data.result[lengths].totalBonus -
            data.result[lengths - 1].totalBonus) /
            data.result[lengths].totalBonus) *
          100
        ).toFixed(6);
        }
        this.Bonusnum = data.result[lengths].totalBurned;
        if (lengths > 0) {
        this.Bonusnumf = (
          ((data.result[lengths].totalBurned -
            data.result[lengths - 1].totalBurned) /
            data.result[lengths].totalBurned) *
          100
        ).toFixed(6);
        }
        // this.Burnednumarr.push(data.result[i].totalBurned);
        // this.Bonusnumarr.push(data.result[i].totalBonus);
        this.Burnednumarr.push(data.result[i].totalBonus);
        this.Bonusnumarr.push(data.result[i].totalBurned);
        // console.log(this.Burnednumarr);
        // console.log(this.Bonusnumarr);
        // Burnednum:"",
        // Bonusnum:"",
        // Burnednumarr:[],
        // Bonusnumarr:[],
        this.initChartsa();
        this.initChartsb();
      }
    },
    currentTime() {
      setInterval(this.formatDate, 500);
    },
    initWebSocket() {
      //192.168.1.216
      const wsuri = "wss://explorer.tfsc.io/tfscBrowser/websocket";
      //http://192.168.1.123:9200
      //   const wsuri = "ws://192.168.1.123:9200/tfscBrowser/websocket";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      this.start();
    },
    websocketonerror() {
      this.reconnect();
    },
    websocketonmessage(event) {
      const that = this;
      const data = JSON.parse(event.data);
      // console.log("data:" + event.data);
      //   console.log(data);
      if (data.height !== 0) {
        if (data.type == "currentTPS") {
          that.tpsCount = data.tpsCount;
        } else {
          // that.maxGas = "";
          // that.maxGas = data.currentGas;
          // that.tpsCount = "";
          // blockHeight
          that.currentHeight = data.blockHeight;
          that.totalTxCount = data.txCount;
          that.currentGas = data.currentGas;
          that.currentTPS = data.tpsCount;
          var strdatea = Math.floor(data.linuxTime / 1000);
          that.latestTranstion = that.latestTranstion.slice(0, 14);
          //    console.log(that.latestTranstion);
          for (var m = 0; m < that.latestTranstion.length; m++) {
            that.latestTranstion[m].class = " ";
          }
          var socketMapList = data.socketMapList;

          that.ditudata = [];
          that.ditudata = socketMapList;
          //  console.log(that.ditudata);
          if (
            that.myChart !== null &&
            that.myChart !== " " &&
            that.myChart !== "undefined"
          ) {
            that.barsChartFun();
          }
          let wblockList = data.blockList;
          //    console.log(wblockList);
          that.latestBlock = that.latestBlock.slice(0, 3);
          for (let jj = 0; jj < that.latestBlock.length; jj++) {
            that.latestBlock[jj].class = " ";
          }
          that.PackerList = [];
          for (let i = 0; i < wblockList.length; i++) {
            //    console.log(wblockList);
            if (
              wblockList[i].packerName == "" ||
              wblockList[i].packerName == null
            ) {
              wblockList[i].packerName = getSubStr(wblockList[i].packer, 0, 8);
            } else {
              wblockList[i].packerName = wblockList[i].packerName;
            }
            // if(wblockList[i].packerLogo=='' || wblockList[i].packerLogo==null ){
            //   wblockList[i].packerLogo=that.imgurl;
            // }else{
            //   wblockList[i].packerLogo=wblockList[i].packerLogo;
            // }
            that.PackerList.push({
              packerName: wblockList[i].packerName,
              packerLogo: wblockList[i].packerLogo,
              packer: wblockList[i].packer,
            });
            //     console.log(that.PackerList);
            wblockList[i].class = "active";
            let timestampa = Math.floor(wblockList[i].blockTime / 1000);
            let ss = strdatea - timestampa;
            if (ss <= 0) {
              ss = 1;
            }
            that.newData.unshift(ss);
            that.newData.pop();
            that.newData.slice(0, 10);
            wblockList[i].tradeTime = formatSeconds(ss);
            that.latestBlock.unshift(wblockList[i]);
          }
          //处理打包者
          //     console.log(that.PackerList);
          // for(var i=0;i<this.latestPackers.length;i++){
          //   this.latestPackers[i].class=" ";
          // }
          that.latestPackers = [];
          for (var ii = 0; ii < that.PackerList.length; ii++) {
            if (that.PackerList[ii].packerLogo == "") {
              that.PackerList[ii].packerLogo = that.imgurl;
            }
            // if(that.PackerList[ii].packerName==""){
            //   that.PackerList[ii].packerName= getSubStr(that.PackerList[ii].packer, 0, 3);
            // }
            // packer: "14GHF5zrZqzhtyxsH3afpMf7vpiWQGyPNp"
            //  packerName: "14GH...yPNp"
            // this.PackerList[ii].packerName= getSubStr(this.PackerList[ii],0,6);
            // console.log(this.PackerList[ii].packerName);
            that.latestPackers.unshift({
              class: "activea",
              packer: that.PackerList[ii].packer,
              packerName: that.PackerList[ii].packerName,
              packerLogo: that.PackerList[ii].packerLogo,
            });
            //  this.latestPackers = (this.latestPackersa.concat(latestPackers)).slice(0,10);
            //   console.log(this.latestPackers);
          }
          //   console.log(that.latestPackers);
          let txList = data.txList;
          //  console.log(txList);
          //  that.lastTranstion[j].type1 = listType(that.lastTranstion[j].type);
          that.lastTranstion = that.lastTranstion.slice(0, 9);
          for (let jj = 0; jj < that.lastTranstion.length; jj++) {
            if (this.lastTranstion[jj].toAddress == "Pledge") {
              this.lastTranstion[jj].toAddress = "Stake";
            }
            that.lastTranstion[jj].class = " ";
            // if(this.lastTranstion[jj].type=='setBaseTokenURI' && this.lastTranstion[jj].symbol==''){
            //   this.lastTranstion[jj].symbol=this.lastTranstion[jj].contractName;
            //   console.log('执行了');
            // }
          }
          for (let j = 0; j < txList.length; j++) {
            txList[j].type1 = txList[j].type;

            txList[j].class = "active";
            let timestampaa = Math.floor(txList[j].tradeTime / 1000);
            let s = strdatea - timestampaa;
            if (s <= 0) {
              s = 1;
            }
            // if(this.txList[j].type=='setBaseTokenURI' && this.txList[j].symbol==''){
            //   this.txList[j].symbol=this.txList[j].contractName;
            //   console.log('执行了');
            // }

            that.Time2[j] = formatSeconds(s);
            that.newData1.unshift(s);
            that.newData1.pop();
            that.newData1.slice(0, 10);
            if (txList[j].toAddress == "Pledge") {
              txList[j].toAddress = "Stake";
            }
            //开始加的类容
            //  console.log(txList[j]);
            if (
              (txList[j].nftNameList !== "" ||
                txList[j].nftNameList !== null) &&
              txList[j].standard == "ERC-721"
            ) {
              if (
                typeof txList[j].nftNameList === "string" &&
                txList[j].nftNameList !== ""
              ) {
                if (typeof JSON.parse(txList[j].nftNameList) == "object") {
                  txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
                } else {
                  txList[j].nftNameList = txList[j].nftNameList;
                }
                // console.log('字符串');
                txList[j].nftNameList = txList[j].nftNameList;
              } else if (typeof txList[j].nftNameList === "object") {
                // console.log('对象');
                if (Array.isArray(txList[j].nftNameList)) {
                  txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
                }
              }
              // txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
              // txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
              txList[j].symbol = "";
            }
            txList[j].txHash1 = getSubStr(txList[j].txHash, 0, 6);
            // console.log(txList[j]);
            txList[j].type = listType(txList[j].type);
            if (txList[j].type1 == 7 && txList[j].standard == "ERC-721") {
              if (txList[j].symbol.trim() == "") {
                txList[j].symbol = getSubStr(txList[j].contractAddress, 0, 3);
              }
            }

            if (txList[j].type1 == 8) {
              txList[j].type = txList[j].functions;
              txList[j].toAddress = txList[j].toEvmAddress;
              txList[j].fromAddress = txList[j].fromEvmAddress;
            }
            if (
              txList[j].type1 == 8 &&
              txList[j].standard == "ERC-721" &&
              txList[j].type == "mint"
            ) {
              // console.logo(txList[j]);
              // console.logo('mint走了这里');
              if (
                txList[j].nftNameList !== "" ||
                txList[j].nftNameList !== null
              ) {
                // if (typeof str == "string") {
                //   try {
                //     JSON.parse(str);
                //     return true;
                //   } catch (e) {
                //     console.log(e);
                //     return false;
                //   }
                // }
                // txList[j].nftNameList = JSON.parse(txList[j].nftNameList)[0];
                if (
                  typeof txList[j].nftNameList === "string" &&
                  txList[j].nftNameList !== ""
                ) {
                  txList[j].nftNameList = txList[j].nftNameList;
                } else if (typeof txList[j].nftNameList === "object") {
                  if (Array.isArray(txList[j].nftNameList)) {
                    txList[j].nftNameList = JSON.parse(
                      txList[j].nftNameList
                    )[0];
                  }
                } else {
                  if (
                    txList[j].type1 == 8 &&
                    txList[j].standard == "ERC-721" &&
                    txList[j].symbol == ""
                  ) {
                    if (txList[j].contractName.trim() !== "") {
                      txList[j].nftNameList = txList[j].contractName;
                    } else {
                      txList[j].nftNameList = txList[j].tokenAmount;
                      //新加的
                      //  txList[j].nftNameList = getSubStr(txList[j].contractAddress,0,3);
                    }
                  }
                }
                // txList[j].symbol = "";
              }

              if (txList[j].symbol == "") {
                txList[j].symbol = txList[j].contractName;
              }
              // if(this.txList[j].symbol==''){
              //   this.txList[j].symbol=this.txList[j].contractName;
              // }
            }
            if (
              txList[j].type1 == 8 &&
              txList[j].standard == "ERC-721" &&
              txList[j].type == "setBaseTokenURI"
            ) {
              if (txList[j].symbol == "") {
                txList[j].symbol = txList[j].contractName;
              }
            }
            if (
              txList[j].type1 == 8 &&
              txList[j].standard == "ERC-721" &&
              txList[j].type == "transferFrom"
            ) {
              // console.log('transferFrom走了这里');
              if (txList[j].nftNameList == "") {
                if (txList[j].contractName !== "") {
                  txList[j].nftNameList = txList[j].contractName;
                } else {
                  txList[j].nftNameList = txList[j].tokenAmount;
                }
              }
            }
            //为特殊类型的时候
            if (
              txList[j].type1 == 8 &&
              txList[j].standard == "ERC-721" &&
              txList[j].functions == "Contract Execute"
            ) {
              //  console.log('走这里');
              if (txList[j].nftNameList == "") {
                if (txList[j].contractName.trim() !== "") {
                  txList[j].nftNameList = txList[j].contractName;
                } else {
                  txList[j].nftNameList = txList[j].tokenAmount;
                }
              }
            }
            if (txList[j].type1 == 8 && txList[j].standard == "ERC-721") {
              if (txList[j].symbol == "") {
                //  console.log(11111);
                txList[j].symbol = txList[j].contractName;
              } else {
                txList[j].symbol = txList[j].symbol;
              }
            }

            if (txList[j].type1 == 7 && txList[j].standard == "ERC-721") {
              if (txList[j].symbol == "") {
                //  console.log(11111);
                txList[j].symbol = txList[j].contractName;
              }
            }
            if (
              (txList[j].type1 == 8 || txList[j].type1 == 7) &&
              txList[j].standard == "ERC-20"
            ) {
              if (
                txList[j].tokenAmount !== "" ||
                txList[j].tokenAmount !== null
              ) {
                if (
                  txList[j].tokenAmount > 0 &&
                  txList[j].tokenAmount !== null
                ) {
                  if (txList[j].tokenAmount.length <= 7) {
                    console.log(txList[j].tokenAmount);

                    txList[j].tokenAmount = txList[j].tokenAmount.slice(0, 7);
                  } else {
                    txList[j].tokenAmount =
                      txList[j].tokenAmount.slice(0, 8) + "...";
                  }
                } else {
                  txList[j].tokenAmount = txList[j].tokenAmount;
                }
              }
            }
            // console.log(txList[j]);

            //结束加的类容
            that.lastTranstion.unshift(txList[j]);
          }
        }
      }

      that.reset();
    },
    websocketsend(Data) {
      this.websock.send(Data);
    },
    websocketclose(e) {
      this.reconnect();
    },
    reconnect() {
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      var that = this;
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      that.start();
    },
    start() {
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        if (self.websock.readyState == 1) {
          self.websock.send("pcheartCheck");
        } else {
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    onMounted() {
      // const marquee = document.getElementById("barList");
      // marquee.innerHTML = marquee.innerHTML + marquee.innerHTML;
    },
    shijian() {
      var that = this;
      var tblEle = document.getElementsByClassName("block-time-span");
      var tblEle1 = document.getElementsByClassName("block-time-span1");
      that.timer = setInterval(() => {
        that.$nextTick(function () {
          for (let i = 0; i < that.newData.length; i++) {
            that.newData[i]++;
            if (that.newData[i] != null && tblEle[i] !== undefined) {
              tblEle[i].innerHTML =
                "<span>" + formatSeconds(that.newData[i]) + "</span>";
            }
          }
        });
      }, 1000);
      that.$once("hook:beforeDestroy", () => {
        clearInterval(that.timer);
      });
      that.timer2 = setInterval(() => {
        that.$nextTick(function () {
          for (let j = 0; j < that.newData1.length; j++) {
            that.newData1[j]++;
            if (that.newData1[j] != null && tblEle1[j] !== undefined) {
              tblEle1[j].innerHTML =
                "<span>" + formatSeconds(that.newData1[j]) + "</span>";
            }
          }
        });
      }, 1000);
      that.$once("hook:beforeDestroy", () => {
        clearInterval(that.timer2);
      });
    },
    ADdress() {
      this.$router.push("/pc/BkHash");
    },
    router(index) {
      let params = this.verifyList[index].toAddress.split(",");
      this.$router.push({ path: "/pc/BkHash", query: { query: params[0] } });
    },
    BkDetail(index) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: index },
      });
    },
    More() {
      this.$router.push("/pc/BlockList");
    },
    More1() {
      this.$router.push("/pc/TransactionsList");
    },
    To(index) {
      //  console.log(index);
      let params = {
        txHash: this.lastTranstion[index].txHash,
        type: this.lastTranstion[index].type1,
        standard: this.lastTranstion[index].standard,
      };
      //   console.log(params);
      this.$router.push({ path: "/pc/To", query: params });
      // this.$router.push({
      //   path: "/pc/To",
      //   query: { txHash: this.lastTranstion[index].txHash,type: this.lastTranstion[index].type1, },
      // });
    },
    address2(index) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.latestTranstion[index].address },
      });
    },
    async barsChartFun() {
      let newList4 = [];
      this.myChart = this.$echarts.init(document.getElementById("bars"));
      //  this.myChart.clear();
      var gMapData = this.ditudata;
      //    console.log(gMapData);
      this.gMapDataa = this.cityNationArr;
      //  console.log(this.gMapDataa);
      var jieguo = [];
      if (this.gMapDataa.length > 0 || this.gMapDataa !==undefined) {
        for (var i = 0; i < this.gMapDataa.length; i++) {
          this.gMapDataa[i].dindex = i;
          for (var j = 0; j < gMapData.length; j++) {
            if (
              this.gMapDataa[i].latitude === gMapData[j].latitude &&
              this.gMapDataa[i].longitude === gMapData[j].longitude
            ) {
              jieguo.push(this.gMapDataa[i]);
            }
          }
        }
      }

      jieguo.forEach((item) => {
        if (newList4.indexOf(item) === -1) {
          newList4.push(item);
        }
      });
      //   console.log(newList4);
      var dataindexs = [];
      for (var ii = 0; ii < newList4.length; ii++) {
        dataindexs.push(newList4[ii].dindex);
      }
      var option;
      option = {
        backgroundColor: "rgba(255,255,255,0)",
        tooltip: {
          formatter: function (params) {
            //        console.log(params.value[3]);
            //        console.log(params.value[2]);

            let str = "";
            for (var i = 0; i < params.value[2].length; i++) {
              str += `<div style='color:#959799;font-size:12px;'> ${params.value[3]}, ${params.value[2][i].cityName}<span style="color:#fff;"> ${params.value[2][i].count} Nodes</span></div>`;
            }
            return str;
          },
        },
        geo: {
          type: "map",
          show: true,
          top: 10,
          bottom: 10,
          map: "world",
          roam: false,
          aspectScale: 0.55,
          zoom: 1.3,
          label: {
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              areaColor: {
                image: document.getElementById("imgs"),
                // Image:require("@/assets/pc/Index/map.png"),
                // image: dot, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
                repeat: "repeat", // 是否平铺，可以是 'repeat-x', 'repeat-y', 'no-repeat'
              },
              color: "rgb(31,37,119)",
              borderColor: "#000",
              borderWidth: 0,
            },
            emphasis: {
              areaColor: "none",
              label: {
                show: false,
              },
            },
          },
        },
        series: [
          {
            type: "scatter",
            // zlevel: 1,

            coordinateSystem: "geo",
            symbolSize: 25,
            symbolSize: function (val) {
              //    console.log(val);
              //  console.log(val[2]);
              if (val[2] !== "undefined" || val[2] !== null) {
                let price = val[2].reduce(
                  (sum, e) => sum + Number(e.count || 0),
                  0
                );
                //   console.log(price);

                var length = price.toString().length;
                //      console.log(length);
              }
              if (length == 0) {
                return 10;
              } else if (length == 1) {
                return 10;
              } else if (length == 2) {
                return 15;
              } else if (length == 3) {
                return 20;
              } else if (length == 4) {
                return 25;
              }
            },

            itemStyle: {
              normal: {
                color: "#00E79A",
              },
            },
            data: this.gMapDataa.map(function (itemOpt) {
              //      console.log(itemOpt);
              return {
                name: itemOpt.num,
                value: [
                  itemOpt.longitude,
                  itemOpt.latitude,
                  itemOpt.cityList,
                  itemOpt.nationName,
                ],
                label: {
                  normal: {
                    show: true,
                    position: "inside",
                    formatter: "{b}",
                    textStyle: {
                      color: "rgba(255,255,255,0.9000)",
                      fontWeight: "100",
                      position: "left",
                      left: 10,
                      fontSize: 11,
                    },
                  },
                },
                showEffectOn: "render",
                rippleEffect: {
                  brushType: "stroke",
                },
                hoverAnimation: true,
              };
            }),
          },
          {
            type: "effectScatter",
            zlevel: 1,
            animation: false,
            coordinateSystem: "geo",
            legendHoverLink: true,
            hoverAnimation: true,
            effectType: "ripple",
            showEffectOn: "render",
            rippleEffect: {
              period: 2.5,
              scale: 2.5,
              brushType: "stroke",
            },
            // effect: {
            //   show: false,

            // },
            symbolSize: function (val) {
              //       console.log(val);
              let price = val[2].reduce(
                (sum, e) => sum + Number(e.count || 0),
                0
              );
              //      console.log(price);
              //               var sum;
              //               val[2].forEach(item =>{
              // sum += item;
              // });
              //     console.log(sum);

              var length = price.toString().length;
              // var length = val[2].toString().length;
              if (length == 0) {
                return 10;
              } else if (length == 1) {
                return 10;
              } else if (length == 2) {
                return 15;
              } else if (length == 3) {
                return 20;
              } else if (length == 4) {
                return 24;
              }
            },
            itemStyle: {
              normal: {
                color: "#00E79A",
              },
            },
            data: newList4.map(function (itemOpt) {
              return {
                name: itemOpt.num,
                value: [
                  itemOpt.longitude,
                  itemOpt.latitude,
                  itemOpt.cityList,
                  itemOpt.nationName,
                  // itemOpt.num,
                  // itemOpt.city,
                  //  itemOpt.dindex,
                ],
                label: {
                  normal: {
                    show: true,
                    position: "inside",
                    formatter: "{b}",
                    textStyle: {
                      color: "rgba(255,255,255,0.9000)",
                      fontWeight: "100",
                      fontSize: 11,
                    },
                  },
                },
                zlevel: 1,
                showEffectOn: "render",
                rippleEffect: {
                  brushType: "stroke",
                },
                hoverAnimation: true,
              };
            }),
          },
        ],
      };
      //    console.log(this.myChart);
      //option.series[1].clear();
      // this.myChart.series[1].clear();
      option && this.myChart.setOption(option);
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    BkHash(index) {
      this.$router.push({
        path: "/pc/BkDetail",
        query: { blockHash: this.latestBlock[index].blockHash },
      });
    },
    Mores() {
      this.flags = true;
      this.stopMove();
    },
    stopMove() {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "17px";
    },
    none(e) {
      this.flags = e;
    },
    add() {
      let _args = arguments;
      let _pointArray = Array.prototype.map.call(_args, (item) => {
        let _itemArray = item.toString().split(".");

        return _itemArray.length > 1 ? _itemArray[1].length : 0;
      });
      let _maxPoint = Math.max.apply(null, _pointArray);
      let _scale = Math.pow(10, _maxPoint);
      return (
        Array.prototype.reduce.apply(_args, [(a, b) => a + b * _scale, 0]) /
        _scale
      );
    },
  },
  beforeDestroy() {
    clearInterval(this.Time);
    if (this.formatDate) {
      clearInterval(this.formatDate);
    }
    if (this.timerall) {
      clearInterval(this.timerall);
    }
    if (this.timerall2) {
      clearInterval(this.timerall2);
    }
    if (this.timeouts) {
      clearTimeout(this.timeouts);
    }
  },
};
</script>
<style scoped>
.progress {
  width: 188px;
}
.el-progress {
  display: flex;
  margin-top: 4px;
}

.progress ::v-deep.el-progress-bar__outer {
  border-radius: 6px !important;
  border: none;
  width: 190px;
  height: 12px !important;
  background: #13161b;
  opacity: 1;
  margin-left: 0px !important;
}

.progress ::v-deep .el-bg-inner-running .el-progress-bar__inner {
  border-radius: 0px 6px 6px 0px;
  background-color: unset;
  height: 12px;
  background-image: linear-gradient(to right, #00e79a, #00e79a);
}
</style>
<style lang="less" scoped>
.Hombox_list {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  .Hombox_left {
    width: 480px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .Hblbox {
      width: 230px;
      height: 126px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      display: flex;

      margin-bottom: 20px;
      .Hblbox_l {
        margin-right: 10px;
        img {
          margin-top: 20px;
          margin-left: 20px;
          width: 46px;
          height: 46px;
        }
      }
      .rights {
        margin-left: 20px;
      }
      .Hblbox_r {
        .Hblbox_title {
          margin-top: 20px;
          height: 17px;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 17px;
          img {
            width: 13px;
            height: 13px;
            margin-left: 5px;
            margin-top: 5px;
          }
        }
        .Hblbox_content {
          height: 29px;
          font-size: 20px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          line-height: 29px;
          margin-top: 4px;
          //cursor: pointer;
        }
        .Hblbox_content:hover {
          color: #00a870;
        }
        .Hblbox_bott {
          display: flex;
          margin-top: 12px;
          .boxnum {
            height: 20px;
            font-size: 14px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00e79a;
            line-height: 20px;
          }
          .boxtit {
            margin-left: 12px;
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 17px;
          }
        }
      }
    }
  }
  .Hombox_right {
    .Homrightbox {
      width: 658px;
      margin-bottom: 20px;
      height: 199px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      .Hombox_shang {
        margin-left: 20px;
        display: flex;
        justify-content: space-between;
        .Hombox_sl {
          padding-top: 19px;
          .Homslbox {
            margin-bottom: 18px;
            .Homslt {
              width: 126px;
              height: 20px;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.5);
              line-height: 20px;
            }
            .Homslc {
              height: 23px;
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              line-height: 22px;
              margin-top: 4px;
              // color:red;
            }
            .Homslc:hover {
              color: #00a870;
            }
          }
        }
        .Hombox_sr {
          position: relative;
          .hombottn {
            z-index: 99;
            display: flex;
            width: 48px;
            height: 25px;
            background: #242931;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            margin-top: 20px;
            margin-right: 20px;
            div {
              height: 17px;
              font-size: 12px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 17px;
              margin-top: 4px;
              margin-left: 7px;
            }
            img {
              width: 16px;
              height: 15px;
              margin-top: 5px;
              margin-left: 2px;
            }
          }
          .headcontent {
            width: 48px;
            height: 108px;
            background: #15171a;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            position: absolute;
            left: 0px;
            top: 50px;
            z-index: 88;
            ul {
              // margin: 12px;
              margin-left: 12px;
              li:nth-child(1) {
                margin-top: 5px;
              }
              li {
                height: 21px;
                line-height: 21px;
                cursor: pointer;
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #8e9093;
              }
              .active {
                cursor: pointer;
                color: #00a870;
              }
            }
          }
        }
      }
      .Hombox_xia {
        margin-left: 20px;
        display: flex;
        .Hombox_xl {
          // padding-top: 10px;
          .Homslbox {
            margin-bottom: 18px;
            .Homslt {
              width: 126px;
              height: 20px;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.5);
              line-height: 20px;
              img {
                width: 13px;
                height: 13px;
                margin-left: 5px;
                margin-top: 2px;
              }
            }
            .Homslc {
              height: 23px;
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              line-height: 22px;
              //color:red;
            }
            .Homslc:hover {
              color: #00a870;
            }
          }
        }
        .Hombox_xr {
          .charts {
            margin-top: 10px;
            width: 503px;
            height: 117px;
            // box-shadow: 8px 9px 6px 0px rgba(211, 248, 90, 0.6);
            opacity: 1;
            // border: 2px solid #d3f85a;
            div {
              width: 503px;
              height: 117px;
            }
          }
        }
      }
    }
  }
}
.chart_list {
  width: 1160px;
  height: 226px;
  background: #000000;
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  margin-top: 70px;
  .chart_box {
    .chart_shang {
      display: flex;
      justify-content: space-between;
      .chart_sleft {
        margin-top: 20px;
        margin-left: 20px;
        font-size: 16px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #9e9e9e;
        line-height: 23px;
      }
      .chart_sright {
        position: relative;
        .hombottn {
          z-index: 99;
          display: flex;
          width: 48px;
          height: 25px;
          background: #242931;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          margin-top: 20px;
          margin-right: 20px;
          div {
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            line-height: 17px;
            margin-top: 4px;
            margin-left: 7px;
          }
          img {
            width: 16px;
            height: 15px;
            margin-top: 5px;
            margin-left: 2px;
          }
        }
        .headcontent {
          width: 48px;
          height: 108px;
          background: #15171a;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          position: absolute;
          left: 0px;
          top: 50px;
          z-index: 88;
          ul {
            // margin: 12px;
            margin-left: 12px;
            li:nth-child(1) {
              margin-top: 5px;
            }
            li {
              height: 21px;
              line-height: 21px;
              cursor: pointer;
              font-size: 12px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #8e9093;
            }
            .active {
              cursor: pointer;
              color: #00a870;
            }
          }
        }
      }
    }
    .chart_xia {
      display: flex;
      justify-content: space-between;
      .chart_xleft {
        //border: 1px solid red;
        width: 260px;
        .chart_xbox {
          margin-top: 32px;
          margin-left: 20px;
          .chart_title {
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #9e9e9e;
            line-height: 17px;
          }
          .chart_content {
            height: 26px;
            margin-top: 6px;
            display: flex;
            .chart_num {
              font-size: 18px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              line-height: 26px;
            }
            .chart_num:hover {
              color: #00a870;
            }
            .charcolor {
              background: #4e5b24 !important;
              color: #d3f85a !important;
            }
            .chart_butttn {
              // width: 48px;
              padding-left: 4px;
              padding-right: 4px;
              height: 25px;
              line-height: 25px;
              background: #0d5441;
              border-radius: 6px 6px 6px 6px;
              opacity: 0.5;
              margin-left: 5px;
              font-size: 12px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              opacity: 0.8;
              color: #00e79a;
              span {
                color: #00e79a;
                opacity: 1;
              }
            }
          }
        }
      }
      .chart_xright {
        width: 974px;
        height: 161px;
      }
    }
  }
}

.Home {
  width: 100%;
  background: #13161b;
  .Home-W {
    width: 1160px;
    margin: 0 auto;
    padding: 40px 0;
    background: #13161b;
    .swiper {
      margin: 20px 0;
      height: 220px;
      background: #000;
      border-radius: 12px 12px 12px 12px;
      padding: 20px 0;
    }
    .Letest {
      margin-bottom: 20px;
      .Home_letest {
        height: 356px;
        display: flex;
        .Home_LetestT {
          flex: 0 0 50%;
          width: 555px;
          height: 409px;
          background: #000000;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;
          margin-right: 20px;
          .Home_LetestT_trans {
            display: flex;
            margin-bottom: 21px;
            padding: 20px 20px 0 20px;
            span:nth-child(1) {
              flex: 0 0 90%;
              text-align: left;
              height: 24px;
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #898b8d;
              // color:red;
              line-height: 24px;
              -webkit-background-clip: text;
            }
            span:nth-child(2) {
              flex: 0 0 10%;
              text-align: right;
              background: #242931;
              border-radius: 6px 6px 6px 6px;
              opacity: 1;
              height: 24px;
              font-size: 12px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 20px;

              cursor: pointer;
              img {
                width: 14px;
                height: 14px;
                margin-top: 4px;
              }
            }
          }
          .Home_Swiper_all {
            display: flex;
            margin-bottom: 8px;
            .Home-swiper_p:nth-child(9) {
              border-bottom: none !important;
            }
            .Home-swiper_p {
              flex: 0 0 80%;
              //  border-bottom: 1px solid red;
              border-bottom: 1px solid #1d2128;
              padding-bottom: 8px;
              .Home-swiper_P1 {
                display: flex;
                .Home-swiper_P2 {
                  flex: 0 0 45%;
                  overflow: hidden;
                  p:nth-child(1) {
                    font-size: 12px;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #fff;
                    line-height: 22px;
                    -webkit-background-clip: text;
                    margin-bottom: 6px;
                    cursor: pointer;
                  }
                  p:nth-child(1):hover {
                    color: #00a870;
                  }
                  p:nth-child(2) {
                    font-size: 12px;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.5);
                    line-height: 20px;
                    -webkit-background-clip: text;
                  }
                }
                .Home-swiper_P3 {
                  // flex: 0 0 70%;
                  p {
                    position: relative;
                    span:nth-child(1) {
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                      color: rgba(255, 255, 255, 0.5);
                      line-height: 22px;
                      -webkit-background-clip: text;
                      margin-right: 2px;
                      cursor: pointer;
                    }
                    span:nth-child(2) {
                      position: absolute;
                      top: 2px;
                      display: inline-block;
                      width: 162px;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                      color: #ffffff;
                      -webkit-background-clip: text;
                      margin-right: 2px;
                      cursor: pointer;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    span:nth-child(2):hover {
                      color: #00a870;
                    }
                    .toAddress {
                      cursor: text !important;
                      color: rgba(255, 255, 255, 0.9) !important;
                    }
                    .FromActive {
                      cursor: text !important;
                      color: rgba(255, 255, 255, 0.9) !important;
                    }
                  }
                  p:nth-child(1) {
                    margin-bottom: 4px;
                  }
                }
              }
            }
            .Home-swiper_p1 {
              flex: 0 0 20%;
              border-bottom: 1px solid #1d2128;
              p {
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.5);
                line-height: 28px;
                -webkit-background-clip: text;
                padding-left: 8px;
                cursor: default;
                width: 127px;
                text-align: center;
              }
              .buttons {
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.5);
                line-height: 20px;
                width: 100px;
                // padding: 2px 0;
                background: #242931;
                border-radius: 4px 4px 4px 4px;
                opacity: 1;
                // width: 88px;
                border: 1px solid #000000;
                text-align: center;
                margin-left: 26px;
                margin-bottom: 10px;
              }
              //padding-top: 8px;
              position: relative;
              span {
                display: inline-block;
                position: absolute;
                top: 35px;
                left: 35px;
                width: 60px;
                height: 20px;
                background: #4b5b76;
                font-size: 12px;
                font-family: SF Pro Text-Regular, SF Pro Text;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.9);
                line-height: 20px;
                text-align: center;
                display: none;
                cursor: default;
                i {
                  font-size: 13px;
                  color: #4b5b76;
                  position: absolute;
                  top: -11px;
                  left: 23px;
                  border-radius: 2px;
                }
              }
            }
            // .Home-swiper_p4:hover {
            //   p {
            //     width: 127px;
            //     height: 28px;
            //     background: #3c485c;
            //     border-radius: 8px 8px 8px 8px;
            //   }
            //   span {
            //     display: block;
            //     border-radius: 2px;
            //   }
            // }
          }
        }
        .Home_Letest_Ul {
          flex: 0 0 48%;
          width: 585px;
          height: 409px;
          background: #000000;
          border-radius: 20px 20px 20px 20px;
          opacity: 1;

          .index_content {
            .indexChart {
              flex-direction: row;
              .indexChart-item {
                //width: 100%;
                // width: 585px;
                opacity: 1;
                position: relative;
                img {
                  // border: 1px solid yellow;
                }
                .barsBox {
                  width: 548px;
                  height: 303px;
                  // border: 1px solid red;
                  position: absolute;
                  top: 0px;
                  left: 0px;
                }
                .barflex {
                  position: absolute;
                  top: 246px;
                  .barnum {
                    margin-top: 4px;
                    span:nth-child(1) {
                      font-size: 12px;
                      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                      font-weight: 500;
                      color: #00e79a;
                      margin-left: 24px;
                    }
                    span:nth-child(2) {
                      margin-left: 4px;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                      font-weight: 500;
                      color: #898b8d;
                    }
                  }
                }
                .barfoot {
                  margin-top: 20px;
                  margin-left: 24px;
                  .barfootit {
                    height: 50px;
                    font-size: 12px;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #898b8d;
                    line-height: 50px;
                  }
                  .barfootlist {
                    display: flex;
                    // margin-top: 8px;
                    overflow: hidden;
                    .barmquee {
                      display: flex;
                      height: 30px;
                      // width: calc(5 * 140px);
                      //  border: 1px solid red;
                      .barfli {
                        margin-right: 20px;
                        // width: 106px;
                        // height: 60px;
                        //border: 1px solid red;
                        // position: absolute;
                        display: flex;

                        //  animation: mquees 15s ease 3s infinite;

                        img {
                          width: 18px;
                          height: 18px;
                          margin-right: 10px;
                          border-radius: 50%;
                        }
                        span {
                          width: 60px;
                          display: inline-block;
                          // border: 1px solid yellow;
                          height: 17px;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          -o-text-overflow: ellipsis;
                          font-size: 12px;
                          font-family: Source Han Sans CN-Regular,
                            Source Han Sans CN;
                          font-weight: 400;
                          color: #ffffff;
                          line-height: 17px;
                        }
                      }
                      .list {
                        // animation-name: change;
                        // animation-duration: 1s;
                        // animation-iteration-count: 1;
                      }

                      @keyframes change {
                        0%,
                        20%,
                        100% {
                          transform: translate3d(0, 0, 0);
                        }
                        25%,
                        45% {
                          transform: translate3d(0, -33.33%, 0);
                        }
                        50%,
                        70% {
                          transform: translate3d(0, -66.66%, 0);
                        }
                        75%,
                        95% {
                          transform: translate3d(0, -33.33%, 0);
                        }
                      }
                      // .marquee {
                      //   display: flex;
                      //   // animation: marquee 15s linear 1;
                      //   // animation: marquee 15s linear 1s infinite;
                      // }
                      // @keyframes marquee {
                      //   // 0% {
                      //   //   transform: translateX(0%); //这里不是-100%！
                      //   // }
                      //   // 100% {
                      //   //   transform: translateX(-11%);
                      //   // }
                      //   0% {
                      //     transform: translate(calc(0 * 120px));
                      //   }
                      //   25% {
                      //     transform: translate(calc(-1 * 120px));
                      //   }
                      //   50% {
                      //     transform: translate(calc(-2 * 120px));
                      //   }
                      //   75% {
                      //     transform: translate(calc(-3 * 120px));
                      //   }
                      //   100% {
                      //     transform: translate(calc(-4 * 120px));
                      //   }
                      // }
                    }
                  }
                }
                .indexChart-title {
                  font-size: 16px;
                  font-family: SF Pro Text-Medium, SF Pro Text;
                  font-weight: 500;
                  color: rgba(255, 255, 255, 0.9);
                  line-height: 24px;
                  -webkit-background-clip: text;
                  position: relative;
                  margin: 20px 0 9px 20px;
                  box-sizing: border-box;
                  opacity: 1;
                  &:before {
                    // content: "";
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 6px;
                    height: 20px;
                    background: #7644e4;
                    border-radius: 6px 6px 6px 6px;
                  }
                }
                &:last-child {
                }
              }
              #bars {
                width: 100%;
                height: 303px;
                div:nth-child(1) {
                  height: 303px !important;
                }
                ::v-deep canvas {
                }
              }
              #bar {
                width: 626px;
                height: 304px;
              }
            }
            /deep/ .anchorBL {
              display: none;
            }
            /deep/ .highcharts-tooltip {
              pointer-events: initial !important;
              span {
                width: 80px;
                height: 60px;
                line-height: 16px;
                text-align: center;
              }
            }

            /deep/ .myswiper-container {
              padding: 0 20px;
              height: 318px;
              overflow: auto !important;
              scrollbar-width: none;
              -ms-overflow-style: none;
            }
            .scroll::-webkit-scrollbar {
              width: 1px;
              height: 1px;
            }
            .scroll::-webkit-scrollbar-thumb {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
@import url("https://at.alicdn.com/t/font_3404326_aj3ozk51d7f.css");
.Home_letest {
  height: 356px;
  display: flex;
  .Home_LetestT {
    flex: 0 0 60%;
    background: #2c3645;
    border-radius: 16px 0px 0px 16px;
    .indexChart {
      flex-direction: row;
      .indexChart-item {
        width: 100%;
        opacity: 1;
        border: 1px solid red;
        .indexChart-title {
          font-size: 16px;
          font-family: SF Pro Text-Medium, SF Pro Text;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
          line-height: 24px;
          -webkit-background-clip: text;
          position: relative;
          margin: 20px 0 9px 20px;
          box-sizing: border-box;
          opacity: 1;
          &:before {
            // content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 20px;
            background: #7644e4;
            border-radius: 6px 6px 6px 6px;
          }
        }
        &:last-child {
        }
      }
      #bars {
        width: 100%;
        height: 303px;
        div:nth-child(1) {
          height: 303px !important;
        }
        ::v-deep canvas {
        }
      }
      #bar {
        width: 626px;
        height: 304px;
      }
    }
    /deep/ .anchorBL {
      display: none;
    }
    /deep/ .highcharts-tooltip {
      pointer-events: initial !important;
      span {
        width: 80px;
        height: 60px;
        line-height: 16px;
        text-align: center;
      }
    }
    // .barsBox {
    //   width: 100%;
    //   height: 303px;
    // }
    /deep/ .myswiper-container {
      padding: 0 20px;
      height: 324px;
      overflow: auto !important;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .scroll::-webkit-scrollbar {
      width: 1px;
      height: 1px;
    }
    .scroll::-webkit-scrollbar-thumb {
      opacity: 1;
    }
  }
}

@import url("https://at.alicdn.com/t/font_3404326_aj3ozk51d7f.css");
@import url("https://at.alicdn.com/t/font_3416757_q3n38igh5j.css");
.Home_swiper-P {
  margin: 0 20px;
  p {
    margin-bottom: 20px;
    span:nth-child(1) {
      font-size: 16px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #898b8d;
      line-height: 24px;
      -webkit-background-clip: text;
      float: left;
    }
    span:nth-child(2) {
      display: flex;
      font-size: 12px;
      font-family: SF Pro Text-Regular, SF Pro Text;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      -webkit-background-clip: text;
      float: right;
      button {
        // width: 51px;
        height: 25px;
        background: #242931;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        border: none;
        cursor: pointer;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        padding-left: 4px;
        .iconfont {
          font-size: 10px;
        }
      }
    }
  }
}
.Home_swiper_Ul {
  overflow: hidden;
  // width: 1320px;
  ul {
    width: 1320px;
    white-space: nowrap;
    height: 142px;
    display: flex;
    // border: 1px solid red;
    li {
      display: inline-block;
      background: #2c3645;
      border-radius: 8px 8px 8px 8px;
      margin-left: 20px;
      overflow: hidden;
      // border: 1px solid red;
      width: 320px;
      height: 142px;
      .yinchang {
        padding: 12px 12px;
        // width: 340px;
        // height: 100px;
        // border: 1px solid red;
        width: 320px;
        // padding: 12px 12px;
        height: 142px;
        background: #13161b;
        // border-radius: 12px 12px 12px 12px;
        opacity: 1;
        .name {
          height: 17px;
          font-size: 12px !important;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
          margin-left: 6px;
        }
        .nameimg {
          width: 20px;
          height: 20px;
          margin-top: 6px;
        }
      }
      p:nth-child(1) {
        span:nth-child(1) {
          font-size: 18px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          -webkit-background-clip: text;
          cursor: pointer;
        }
        span:nth-child(1):hover {
          color: #00a870;
        }
        span:nth-child(2) {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
          line-height: 28px;
          float: right;
          position: relative;
          height: 28px;
          width: 127px;
          text-align: center;
          cursor: default;
          .Fee {
            display: inline-block;
            position: absolute;
            top: 27px;
            left: 44px;
            width: 37px;
            height: 20px;
            background: #4b5b76;
            font-size: 12px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            line-height: 20px;
            text-align: center;
            display: none;
            border-radius: 2px;
            cursor: default;
            i {
              font-size: 13px;
              color: #4b5b76;
              position: absolute;
              top: -11px;
              left: 13px;
              border-radius: 2px;
            }
          }
        }
        span:nth-child(2):hover {
          background: #3c485c;
          border-radius: 8px 8px 8px 8px;
          .Fee {
            display: block;
          }
        }
        margin-bottom: 4px;
      }
      p:nth-child(2) {
        margin-bottom: 8px;
        span {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 20px;
          -webkit-background-clip: text;
        }
        span:nth-child(2) {
          margin-left: 16px;
        }
      }
      p:nth-child(3) {
        position: relative;
        span:nth-child(1) {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 20px;
          margin-right: 4px;
        }
        span:nth-child(2) {
          display: inline-block;
          width: 157px;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #fff;
          line-height: 20px;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          position: absolute;
          top: 0;
        }
        span:nth-child(2):hover {
          color: #00a870;
        }
      }
      p:nth-child(4) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        margin-top: 14px;
        img {
          width: 11px;
          height: 14px;
          margin-top: 2px;
          margin-right: 6px;
        }
      }
    }
    .active {
      -webkit-animation: active 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
      animation: active 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
      will-change: transform, opacity, width;
    }
    @keyframes active {
      0% {
        width: 0px;
        height: 142px;
      }
      100% {
        width: 340px;
        height: 142px;
      }
    }
  }
}
.fadenum1 {
  color: #000;
  animation: fadenum112 3s 1;
}
@keyframes fadenum112 {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
</style>
